import { cn } from '@/lib/utils';

export function PoweredByNotifi({
  className,
  compact = false,
}: {
  className?: string;
  compact?: boolean;
}) {
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center text-gray-400',
        compact ? 'gap-1 text-[7px]' : 'gap-1.5 text-xs',
        className,
      )}
    >
      <img
        src="/brand/notifi-mark-ink.svg"
        alt="Notifi logo"
        className={cn('shrink-0', compact ? 'size-2.5' : 'size-5')}
      />
      <span>
        Powered by <span className="font-medium text-gray-500">Notifi</span>
      </span>
    </div>
  );
}
